import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "-mt-[25px] -mb-[25px] ltr:-ml-[15px] rtl:-mr-[15px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"trezo-card-header mb-[20px] flex items-center justify-between\"><div class=\"trezo-card-title flex items-center gap-[15px]\"><div><span class=\"block mb-[4px]\"> Net Profit </span><h5 class=\"mb-0 md:text-[20px]\">$42,458</h5></div><span class=\"inline-block px-[8.5px] text-success-600 border border-success-300 bg-success-100 text-sm rounded-[100px] text-xs\"> +7.6% </span></div><div class=\"trezo-card-subtitle\"><span class=\"block\"> Last 7 days </span></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "200",
              options: _ctx.netProfit,
              series: _ctx.profit
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}